import { get } from 'lodash';
const map = {};
const KEY_DELIMITER = '%';
const buildKey = (id, key) => `${id}${KEY_DELIMITER}${key}`;
/**
 * Required to handle nested objects
 */
const hotObjectProxy = (source, path) => {
    return new Proxy(source, {
        get: (_, key) => {
            const [id, ...rest] = path.split(KEY_DELIMITER);
            const target = rest.length
                ? get(map[id].current, [...rest])
                : map[id].current;
            if (typeof target[key] === 'object' && target[key] !== null) {
                return hotObjectProxy(target[key], buildKey(path, String(key)));
            }
            else {
                return get(map[id].current, [...rest, key]);
            }
        },
    });
};
// Always trigger functions from map
const hotFunctionProxy = (id) => {
    const func = (...args) => map[id].current(...args);
    // Some parts add information on top of the function (such as - parameters in editorDataFunction)
    Object.assign(func, map[id].current);
    return func;
};
/**
 *
 * @param sourceModule A webpack module (with hot potentially set)
 * @param source Source object to be proxied for changes
 * @param namespace In case there's multiple usages of hotProxy in the same module, we need a way to identify them
 * @returns a proxy that updates on each change
 */
export const hotProxy = (sourceModule, source, namespace = '') => {
    const { id: moduleId } = sourceModule;
    const id = namespace ? `${moduleId}_${namespace}` : moduleId;
    if (!map[id]) {
        map[id] = {};
    }
    map[id].current = source;
    if (sourceModule.hot) {
        sourceModule.hot.accept();
    }
    switch (typeof source) {
        case 'function':
            return hotFunctionProxy(id);
        case 'object':
        default:
            return hotObjectProxy(map[id].current, id);
    }
};
//# sourceMappingURL=hotProxy.js.map